<template>
  <div>
    <nav class="navbar is-transparent">
      <div class="navbar-brand">
        <div class="navbar-item" href="#">
          <img
            src="../assets/fmlogo.png"
            alt="Fast and Reliable connectivity"
            width="110"
            height="28"
          >
        </div>
        <div
          id="icon"
          @click="toNotification"
          class="navbar-item"
          :class="{'is-active':currentPath === 'notifications'}"
        >
          <span class="icon is-big is-left has-badge-rounded" :data-badge="notificationCount">
            <font-awesome-icon icon="bell"/>
          </span>
        </div>
        <div class="navbar-burger burger" @click="menuClick" :class="{'is-active':menuActive}">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      <div class="navbar-menu" :class="{'is-active':menuActive}">
        <div class="navbar-end">
          <router-link
            class="navbar-item"
            to="/account/"
            :class="{'is-active':currentPath === 'session'}"
          >Account</router-link>
          <router-link
            class="navbar-item"
            to="/account/plan"
            :class="{'is-active':currentPath === 'plan'}"
          >Plan</router-link>
          <router-link
            class="navbar-item"
            to="/account/issues"
            :class="{'is-active':currentPath === 'issues'}"
          >Resolve Issue</router-link>
          <a class="navbar-item" @click="logOut()">Logout</a>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data: function() {
    return {
      menuActive: false
    };
  },
  methods: {
    menuClick() {
      this.menuActive = !this.menuActive;
    },
    toNotification() {
      this.$router.push({ name: "notifications" });
    },
    ...mapActions([
      "getUser",
      "populatePricings",
      "getSession",
      "getNotifications",
      "updateListener",
      "getPlan",
      "logOut",
      "setUpRouting",
      "populatePending",
      "getTransactionStatus"
    ]),

  },
  watch: {},
  computed: {
    notificationCount() {
      return this.$store.getters.notificationsNotSeen;
    },
    ...mapState(["serverAuth","currentPath"])
  },
  created: function() {
    this.getUser();
    this.populatePricings();
    this.getSession();
    this.getNotifications();
    this.updateListener();
    this.getPlan();
    this.setUpRouting();
    this.populatePending();
    this.getTransactionStatus();

    /*this.currentPath = this.$route.name;
    this.$router.beforeEach((to, from, next) => {
      if (this.serverAuth) {
        this.menuActive = false;
        this.currentPath = to.name;
        next();
      } else {
        if (to.name === "login" || from.name === "login") {
          next();
        } else {
          next({
            name: "login"
          });
        }
      }
    }); */
  }
};
</script>

<style>
nav {
  box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.11);
}

a.navbar-item:hover {
  border: none;
  border-bottom: 1px solid #00d1b2;
  color: black;
}

a.navbar-item.is-active {
  border: none;
  border-bottom: 2px solid #00d1b2;
  color: #00d1b2;
}

.navbar-item.is-active {
  border: none;
  border-bottom: 2px solid #00d1b2;
  color: #00d1b2;
}

/*#icon:hover {
  border: none;
  border-bottom: 1px solid #00d1b2;
  color: black;
}*/
</style>
